module.exports = __webpack_public_path__ + "static/media/indivibook_white.736c2698.svg";